export default __webpack_public_path__ + "images/3a4c39ec41ab5e23ee57b2e96d67ec2c.png";